var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "si-glyph:circle-error",
    clipPath: "url(#clip0_1899_5622)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E4E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0652 4.93514C15.1571 1.02708 8.82494 1.02079 4.92444 4.92129C1.02142 8.82557 1.02519 15.1552 4.93576 19.0633C8.84382 22.9713 15.1773 22.9764 19.0765 19.0759C22.9783 15.1754 22.9745 8.84319 19.0652 4.93514ZM14.0269 16.2049L11.9023 14.0804L9.77773 16.2049C8.91053 17.0721 8.25856 17.8273 7.22396 16.794C6.19188 15.7606 6.94328 15.1087 7.81426 14.2402L9.93883 12.1169L7.81426 9.99233C6.9458 9.12513 6.19188 8.47316 7.22396 7.43856C8.25856 6.40648 8.91053 7.1604 9.77773 8.02886L11.9023 10.1509L14.0269 8.02886C14.8953 7.16166 15.5435 6.40522 16.5781 7.43856C17.6127 8.47316 16.8588 9.12513 15.9903 9.99233L13.8658 12.1156L15.9903 14.239C16.8575 15.1087 17.6127 15.7606 16.5781 16.794C15.546 17.8273 14.8953 17.0721 14.0269 16.2049Z",
    fill: "#EC4C47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1899_5622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellation);
export default __webpack_public_path__ + "static/media/cancellation.0e6a95f1df788031e4775fa6913f63ee.svg";
export { ForwardRef as ReactComponent };